var _circle, _rect, _line, _line2, _line3, _line4, _line5, _path, _line6, _line7, _line8, _line9, _line10, _line11, _path2, _line12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignatures(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 159,
    viewBox: "0 0 520 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 511.5,
    cy: 16.5,
    r: 8.5,
    fill: "#5DA196",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.5,
    width: 499,
    height: 127,
    rx: 9.5,
    fill: "white",
    stroke: "#DADADA"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 505.508,
    y1: 132.5,
    x2: 505.508,
    y2: 137.073,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 515.07,
    y1: 136.887,
    x2: 511.408,
    y2: 139.626,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 517.657,
    y1: 148.68,
    x2: 513.304,
    y2: 147.276,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 509.663,
    y1: 156.936,
    x2: 508.317,
    y2: 152.565,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 498.16,
    y1: 155.95,
    x2: 500.454,
    y2: 151.993,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492 148.078L496.954 146.192",
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 495.516,
    y1: 136.844,
    x2: 499.06,
    y2: 139.735,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 21.7334,
    y1: 1.5,
    x2: 21.7334,
    y2: 10.0001,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 37.1894,
    y1: 7.8496,
    x2: 30.3826,
    y2: 12.9407,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 41.9401,
    y1: 26.3481,
    x2: 33.8503,
    y2: 23.7391,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 29.7929,
    y1: 39.8986,
    x2: 27.291,
    y2: 31.775,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 11.638,
    y1: 38.95,
    x2: 15.9005,
    y2: 31.5959,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 25.9355L9.52338 23.0715",
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 6.24328,
    y1: 8.98488,
    x2: 12.8303,
    y2: 14.3573,
    stroke: "#EFB76D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatures);
export default __webpack_public_path__ + "static/media/signatures.c298861be56b428ddf4b7c8f82453751.svg";
export { ForwardRef as ReactComponent };